import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  InputSignal,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-filter-data-card',
  templateUrl: './filter-data-card.component.html',
  styleUrls: ['./filter-data-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDataCardComponent {
  @Output()
  openDialog: EventEmitter<void> = new EventEmitter();

  @Output()
  clear: EventEmitter<void> = new EventEmitter();

  showDelete: InputSignal<boolean> = input<boolean>();

  openFilterDialog(): void {
    this.openDialog.emit();
  }

  clearAllFilters(): void {
    this.clear.emit();
  }
}
